export default __webpack_public_path__ + "static/media/times.f272ce73.svg";